export const getIsAuthenticated = state => state.auth.isAuthenticated;